import {createAction} from 'redux-act';

export const OPEN_CANCELLATION_REFUND_MODAL = createAction(
  'cancellationRefundV2/OPEN_CANCELLATION_REFUND_MODAL'
);
export const MAKE_REFUND = createAction('cancellationRefundV2/MAKE_REFUND');
